
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

var script = {
  name: 'PendoDivider',
  props: {
    stroke: {
      type: String,
      default: '#EAECF1'
    },
    strokeWidth: {
      type: Number,
      default: 1
    },
    strokeDasharray: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: '32px'
    },
    width: {
      type: String,
      default: '100%'
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    placement: {
      type: String,
      default: null
    }
  },
  computed: {
    line() {
      if (this.direction === 'vertical') {
        const placement = this.placement || '50%';
        return {
          x1: placement,
          y1: '100%',
          x2: placement,
          y2: '0%'
        };
      }

      const placement = this.placement || '50%';
      return {
        x1: '100%',
        y1: placement,
        x2: '0%',
        y2: placement
      };
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-divider",
    class: {
      'pendo-divider--horizontal': _vm.direction === 'horizontal',
      'pendo-divider--vertical': _vm.direction === 'vertical'
    },
    style: {
      height: _vm.height,
      width: _vm.width
    }
  }, [_vm._t("start"), _vm._v(" "), _c('svg', [_c('line', _vm._b({
    attrs: {
      "stroke": _vm.stroke,
      "stroke-width": _vm.strokeWidth,
      "stroke-dasharray": _vm.strokeDasharray
    }
  }, 'line', _vm.line, false))]), _vm._v(" "), _vm._t("middle"), _vm._v(" "), _vm.$slots.middle ? _c('svg', [_c('line', _vm._b({
    attrs: {
      "stroke": _vm.stroke,
      "stroke-width": _vm.strokeWidth,
      "stroke-dasharray": _vm.strokeDasharray
    }
  }, 'line', _vm.line, false))]) : _vm._e(), _vm._v(" "), _vm._t("end")], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-divider.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoDivider = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoDivider;
